<div class="tw:grid tw:w-full tw:grid-cols-3 tw:sm:grid-cols-4 tw:gap-1 tw:sm:gap-2 tw:py-2">
    @for (option of selectOptions; let i = $index; track i) {
        <ng-container>
            <button
                type="button"
                class="tw:flex tw:min-w-0 tw:flex-1 tw:basis-1/4 tw:items-center tw:justify-center tw:gap-2 tw:h-14 tw:!rounded-2xl tw:px-4 tw:bg-primary-50 tw:text-sm tw:font-semibold tw:text-primary-500"
                [class.tw:bg-primary-500]="selectedValues.includes(option.value)"
                [class.tw:!text-primary-100]="selectedValues.includes(option.value)"
                (click)="toggleValue(option.value)">
                <span class="tw:hidden">
                    <input type="checkbox" [checked]="selectedValues.includes(option.value)" tabindex="-1" class="tw:mr-2" readonly />
                </span>
                @if (selectedValues.includes(option.value)) {
                     <i class="material-icons icon tw:text-primary-100 tw:!py-0 tw:mb-1">check_circle</i>
                }
                <span class="tw:min-w-0 tw:truncate">{{ option.label }}</span>
            </button>
        </ng-container>
    }
</div>

@if (isInvalid && !hideErrorMessage) {
    <div class="tw:mt-2 tw:text-sm tw:text-error-500">
        {{errorMessage}}
    </div>
}
